import { render, staticRenderFns } from "./SchemaSearchSelectMultiple.vue?vue&type=template&id=5a8e4d5f&scoped=true"
import script from "./SchemaSearchSelectMultiple.vue?vue&type=script&lang=js"
export * from "./SchemaSearchSelectMultiple.vue?vue&type=script&lang=js"
import style0 from "./SchemaSearchSelectMultiple.vue?vue&type=style&index=0&id=5a8e4d5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8e4d5f",
  null
  
)

export default component.exports